import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/home/ubuntu/download_production/69dde9479ef881001467a43d/safeplay/node_modules/next/dist/client/app-dir/link.js");
